import VCSearchProgramResults from './VCSearchProgramResults';

export default VCSearchProgramResults;
